import { Pipe, PipeTransform } from '@angular/core';
import { ServiceType } from '../../enums';

@Pipe({
    name: 'serviceTypeDisplayName',
    standalone: false
})
export class ServiceTypeDisplayNamePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case ServiceType.VISITOR_INTEL:
        return 'VisitorIntel';
      case ServiceType.ICP:
        return 'Ideal Customer Profile';
      case ServiceType.JOB_CHANGE:
        return 'Job Change';
      case ServiceType.INTENT:
      default:
        return 'Intent';
    }
  }
}
